import { useCallback } from 'react';

import { useNavigateToAuth } from './useNavigateToAuth/useNavigateToAuth';

const useOpenGlobalOnboarding = () => {
  const { handleNavigateToAuth } = useNavigateToAuth();

  const openLogin = useCallback(
    (redirect: string) => {
      handleNavigateToAuth({ page: 'sign-up', redirect });
    },
    [handleNavigateToAuth]
  );

  return { openLogin };
};

export { useOpenGlobalOnboarding };
